import Sketch from "./sketch.vue";

export default Sketch;
